export enum SurveyTemplateStatuses {
  ACTIVE = 'active',
  DRAFT = 'draft',
  INACTIVE = 'inactive'
}
